// TODO: need to sort countries when dp.app.desktop.js is removed
import { Country } from '@/types/store';

export default function(): Country[] {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return window.$dt?.clcCountry?.toJSON() || [];
}
